import { memo, useMemo } from 'react';
import { Box, Skeleton, useBreakpointProp } from '@bonanza-social/moonlight';
import { groupPrizesByRows } from '../../PrizeWallPrizes/PrizeWallPrizes.utils';
import { ITEMS_PER_ROW } from '../../PrizeWallPrizes/PrizeWallPrizes.content';
import { PrizeWallSkeletonProps } from './PrizeWallSkeleton.types';

function PrizeWallSkeleton(props: PrizeWallSkeletonProps) {
  const itemsPerRow = useBreakpointProp(ITEMS_PER_ROW);
  const items = useMemo(
    () =>
      groupPrizesByRows(
        {
          ids: Array.from({ length: 12 }),
          byId: {},
        },
        itemsPerRow,
      ),
    [itemsPerRow],
  );

  return (
    <Box flex={1} paddingHorizontal="space-400" {...props}>
      <Skeleton
        height={33.7}
        borderRadius="radius-full"
        marginVertical="space-400"
      />
      <Box gap="space-200">
        {items.map((items, rowIndex) => (
          <Box
            key={rowIndex}
            flexShrink={1}
            flexDirection="row"
            gap="space-200"
          >
            {items.map((_, index) => (
              <Skeleton
                key={`${rowIndex}-${index}`}
                flex={1}
                aspectRatio={1}
                maxHeight="100%"
                borderRadius="radius-200"
              />
            ))}
          </Box>
        ))}
      </Box>
      <Skeleton
        height="space-1000"
        marginTop="space-200"
        borderRadius="radius-200"
      />
      <Skeleton
        height="space-1000"
        marginTop="auto"
        borderRadius="radius-200"
      />
    </Box>
  );
}

export default memo(PrizeWallSkeleton);
